export default {
  title: 'Topvarer',
  columns: {
    name: 'Navn',
    quantity: 'Antal',
    amount: 'Beløb',
  },
};
